import * as Sentry from '@sentry/react'
import { downloadBlob } from '@sequencehq/utils'
import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

type UseInvoicesCsvExport = ({
  filtersApiQueryParams
}: {
  filtersApiQueryParams: string
}) => {
  download: {
    available: boolean
    disabled: boolean
    onClick: () => void
  }
}

export const useInvoicesCsvExport: UseInvoicesCsvExport = ({
  filtersApiQueryParams
}) => {
  const { displayPromiseNotification } = useNotifications()

  const downloadCsv = useCallback(async () => {
    const downloadOperation = async () => {
      const invoicesCsvRes =
        await dashboard20240730Client.getInvoicesCsvDownload(
          filtersApiQueryParams
        )

      if (!invoicesCsvRes.data) {
        throw new Error('An error occurred while downloading the invoices')
      }

      downloadBlob('invoice-export.csv')(invoicesCsvRes.data)
      return invoicesCsvRes.data
    }

    await displayPromiseNotification(downloadOperation(), {
      loading: 'Preparing download - this may take a few minutes',
      success: 'Download ready',
      error: 'CSV download failed'
    })
  }, [displayPromiseNotification, filtersApiQueryParams])

  return {
    download: {
      available: true,
      disabled: false,
      onClick: () => void downloadCsv()
    }
  }
}
